import { useSessionAuth } from '@/context/Auth';
import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  id: string;
  userId: string;
  entityId: string;
  userType: string;
  tradingName: string;
  isSuperAdmin?: boolean;
}

export const useLoggedUser = () => {
  const { token } = useSessionAuth();
  const userData = token ? jwtDecode<JwtPayload>(token) : null;

  const isSuperAdmin = userData?.isSuperAdmin && userData.userType === 'ADMIN';

  return {
    userId: userData?.id,
    entityId: userData?.entityId,
    userType: isSuperAdmin ? 'SUPER_ADMIN' : userData?.userType,
    tradingName: userData?.tradingName,
    isSuperAdmin,
  };
};
